'use strict';

import $ from 'jquery';
import 'slick-carousel';

/**
 * home page success section
 *
 * @module home-success
 * @version 0.1.0
 * @author hello@bradenericson.com
 *
 * Generated on 2017-08-31 using @14four/generator-excalibur 0.1.23
 * Converted to ES6 on <current_date> using ChatGPT
 */

class HomeSuccess {

  constructor(element) {
    this.$el = $(element);
    this.setupSlick();
  }

  setupSlick() {
    this.$el.find('.successCarousel').slick({
      autoplay: true,
      arrows: true,
      dots: true,
      infinite: true,
      speed: 1500,
      autoplaySpeed: 4000,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: true,
      draggable: true
    });

    // Once Page fully Loads, fade in slideshow images
    $(window).on('load', () => {
      setTimeout(() => {
        this.$el.find('.successCarousel').removeClass('inactive');
      }, 400);
    });
  }
}

export default HomeSuccess;
